import type { DraftFeedback } from '@/entities/enums/DraftFeedback.ts';
import type { AiDraftFeedbackSubmission } from '@/components/aiDraft/feedback/types.ts';
import type { SmsAiDraftCommonResult, UpdateSmsAiDraftResult } from '@/api/aiDraft/types.ts';

export { AiDraftFailureReason } from '@/api/aiDraft/types.ts';
export type { SmsAiDraftCommonResult, UpdateSmsAiDraftResult } from '@/api/aiDraft/types.ts';

export type SmsAiDraftLocale = 'fr' | 'en';

export const SmsAiDraftState = {
    Idle: 'idle',
    Loading: 'loading',
    Stopped: 'stopped',
    Failed: 'failed',
    NotEntitled: 'notEntitled',
    RateLimited: 'rateLimited',
    ServiceLead: 'serviceLead',
    Inserted: 'inserted',
    UpdateUnsupported: 'updateUnsupported',
} as const;

export type SmsAiDraftState = (typeof SmsAiDraftState)[keyof typeof SmsAiDraftState];

export type SmsAiDraftFeedback = DraftFeedback | null;

export interface SmsAiDraftSnapshot {
    text: string;
}

export interface SmsAiDraftGeneratePayload {
    locale: SmsAiDraftLocale;
    requestId: string;
}

export interface SmsAiDraftUpdatePayload {
    locale: SmsAiDraftLocale;
    requestId: string;
    text: string;
    instruction: string;
}

export interface SmsAiDraftGeneratedDraft {
    locale: SmsAiDraftLocale;
    text: string;
}

export type SmsAiDraftFeedbackSubmission = AiDraftFeedbackSubmission;

export interface SmsAiDraftFeedbackPayload extends SmsAiDraftFeedbackSubmission {
    interactionId: number;
    feedback: DraftFeedback;
}

export interface SmsAiDraftAdapter {
    generate(payload: SmsAiDraftGeneratePayload): Promise<SmsAiDraftCommonResult>;
    update(payload: SmsAiDraftUpdatePayload): Promise<UpdateSmsAiDraftResult>;
    stop(requestId: string): Promise<void>;
    submitFeedback(payload: SmsAiDraftFeedbackPayload): Promise<void>;
}
